// What a tab of Explore is: an entity type, and whether Explore can list it.
// Products is the only active one. The four existing types are shown
// inactive and stay in the existing search until they move in.
//
// A type is added to Explore by setting its tab active and registering, on
// this description, its search, its filters and its result fields.

import { ENTITY_TYPES, EntityTypeKey } from "../../types/entityRegistry";

export interface ExploreTab {
  // The singular type key, e.g. "product"
  type: string;
  // The label of the tab, e.g. "Products"
  label: string;
  // Whether Explore lists this type; an inactive tab cannot be chosen
  active: boolean;
}

// The tab of products, named by the entity registry
export const PRODUCT_TAB: ExploreTab = {
  type: ENTITY_TYPES.product.key,
  label: ENTITY_TYPES.product.pluralLabel,
  active: true,
};

// The types that stay in the existing search until they move into Explore,
// in the order of their tabs
const LATER_TAB_TYPES: EntityTypeKey[] = [
  "organization",
  "facility",
  "project",
  "source",
];

// The tabs, in the order shown: products first, then the types of the
// existing search. A type that is only reached from a detail view (a
// category, a capability part, an incident) has no tab.
export const EXPLORE_TABS: ExploreTab[] = [
  PRODUCT_TAB,
  ...LATER_TAB_TYPES.map((type) => ({
    type,
    label: ENTITY_TYPES[type].pluralLabel,
    active: false,
  })),
];
